<div class="wallet m-sm-30">
  <app-breadcrumb></app-breadcrumb>
  <div class="mb-6">
    <div class="text-2xl mb-2 text-white leading-snug">
      Wallet Information
    </div>
    <p class="m-0 text-muted text-base leading-snug">
      Information about your current wallet and its configuration options
    </p>
  </div>
  <div class="flex flex-wrap md:flex-no-wrap items-center gap-6" *ngIf="!loading && wallet && keymanagerKind">
    <div class="w-full md:w-1/2">
      <app-wallet-kind [kind]="keymanagerKind"></app-wallet-kind>
    </div>
    <div class="w-full md:w-1/2 px-0 md:px-6">
      <mat-tab-group animationDuration="0ms" backgroundColor="primary">
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="mr-4">help</mat-icon>
            Help
          </ng-template>
          <app-wallet-help></app-wallet-help>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="mr-4">folder</mat-icon>
            Files
          </ng-template>
          <app-files-and-directories [wallet]="wallet"></app-files-and-directories>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
